export default {"src":"/_next/static/media/male.85dcc80b.svg","height":67,"width":28,"blurWidth":0,"blurHeight":0};